import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const PhilosophySection = () => {
  return (
    <section className="section-padding bg-white border-t border-black/5">
      <div className="container-wide">
        <div className="grid lg:grid-cols-2 gap-16 lg:gap-24 items-start">
          {/* Left Column - The Problem & Concept */}
          <div className="space-y-8">
            <div>
              <Reveal className="mb-2">
                <p className="label bg-purple text-white px-3 py-1 inline-block">THE PROBLEM</p>
              </Reveal>
              <Reveal className="mb-8 pb-2 !overflow-visible" delay={0.1}>
                <h2 className="display-md text-black">
                  The market is drowning in Noise.
                </h2>
              </Reveal>
            </div>

            <div className="space-y-6">
              <Reveal delay={0.2}>
                <div className="p-6 border border-black/10 transition-colors duration-300 bg-white rounded-xl">
                  <div className="flex items-center gap-4 mb-3">
                    <div className="w-2.5 h-2.5 bg-black/20 rounded-full" />
                    <span className="label text-black/40 mb-0">Noisy Market</span>
                  </div>
                  <p className="text-black leading-relaxed font-light text-sm md:text-base">
                    Where brands compete on volume, follow trends, copy competitors,
                    and chase attention without a clear position. Exhausting and unsustainable.
                  </p>
                </div>
              </Reveal>

              <Reveal delay={0.3}>
                <div className="p-6 border border-purple/20 bg-purple/5 rounded-xl transition-all duration-300 hover:bg-[#c0ff09] group">
                  <div className="flex items-center gap-4 mb-3">
                    <div className="w-2.5 h-2.5 bg-purple rounded-full group-hover:bg-black transition-colors" />
                    <span className="label text-purple group-hover:text-black mb-0">Signal Zone</span>
                  </div>
                  <p className="text-black leading-relaxed font-light group-hover:text-black transition-colors text-sm md:text-base">
                    A distinct strategic territory where your brand becomes the clear choice.
                    Recognizable, differentiated, and chosen, not because you're loudest,
                    but because you're clearest.
                  </p>
                </div>
              </Reveal>

            </div>
          </div>

          {/* Right Column - Illustration */}
          <div className="lg:pt-24 space-y-8">
            <Reveal delay={0.4}>
              <div className="rounded-xl overflow-hidden border border-black/5 bg-white">
                <img
                  src="/assets/images/home/signal-to-noise.png"
                  alt="Signal to Noise illustration"
                  className="w-full h-auto grayscale opacity-90 hover:opacity-100 transition-all duration-500"
                />
              </div>
            </Reveal>

            <Reveal delay={0.5} className="flex justify-start">
              <Link
                to="/why"
                className="inline-flex items-center gap-2 font-light text-black hover:text-[#c0ff09] hover:gap-4 transition-all duration-300"
              >
                Understand the Gap
                <ArrowRight size={16} />
              </Link>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PhilosophySection;
